import { action, extendObservable, makeObservable, computed } from 'mobx'

import DOMPurify from '@client/utils/dompurify'
import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'
import { extractUniqueColors } from '@client/utils/htmlColorExtractor'
import { captureException } from '@client/utils/sentry'

export default class HtmlModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    makeObservable(this)

    this.editor = editor

    this.settings.set({ ...defaultSettings, ...data.settings })

    extendObservable(this, {
      content: DOMPurify.sanitize(data.content) || '',
    })
  }

  @action setContent = (val) => {
    this.content = val
  }

  @computed get allColors() {
    const colors = []

    let htmlColors = []
    try {
      htmlColors = extractUniqueColors(DOMPurify.sanitize(this.content))
    } catch (error) {
      console.error(error)
      captureException(error)
    }

    return Array.from(new Set(colors.concat(htmlColors).filter(Boolean)))
  }

  serialize = () => {
    return {
      type: this.type,
      content: DOMPurify.sanitize(this.content),
      settings: this.settings.serialize(),
    }
  }

  restore = (data) => {
    this.settings.set(data.settings)
    this.content = data.content
  }
}

export const NULL = new HtmlModel()
